export default "__VITE_ASSET__CVEAGyaK__"